
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.25","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M6.875.625h6.25m0 0l3.75 1.25v3.75a2.5 2.5 0 001.667 2.357c.5.177.833.65.833 1.18V16.2c0 .512-.31.97-.786 1.16l-4.811 1.926c-.405.162-.866.1-1.215-.161l-4.438-3.5v-7.5c5-1.875 5-7.5 5-7.5z"}}),_c('path',{attrs:{"d":"M10 7.1C6.876 4.738 6.875.626 6.875.626l-3.75 1.25v3.75a2.5 2.5 0 01-1.667 2.357c-.5.177-.833.65-.833 1.18V16.2c0 .512.312.97.786 1.16l4.812 1.926c.405.162.865.1 1.214-.161L10 17.105m-9.375-3.98h3.75m11.25 0h3.75m-9.062-2.5a.313.313 0 11.625 0 .313.313 0 01-.626 0m.001 3.125a.313.313 0 11.625 0 .313.313 0 01-.626 0"}})])])
          )
        }
      }
    